
/**
 * 使用场景：
 * 
export const [MarketPageDataContextProvider, useMarketPageData] = createTypedContext<IMarketPageData>();

 function Content({loader}: {loader: Promise<IStoreWithData<IMarketPageData>>}){
    const store = use(loader);
    console.log('store=', store);
    return (<MarketPageDataContextProvider value={store.data}>
    <MarketContent />
</MarketPageDataContextProvider>
    )
}
    export default function MarketPage() {
    const loader:Promise<IStoreWithData<IMarketPageData>> = loadMarketPageData();
    return (
                <Suspense fallback={<div>loading</div>}>
                    <Content loader={loader} />
                </Suspense>
        )
}
 */
// 使用场景：
// C:\work\android-droid\html\website-2024-12\libs\fanfanlo\src\react\createTypedContext.ts 的 createTypedContext返回的useTypedContext会需要是promise的，所以我需要一个能够给它传递promise并初始化的组件，可以使用react19的use方法来帮我实现吗？

import { Suspense, use } from "react";
import { IStoreWithData } from "../storage";

// export function TypedContextLoader<T extends Record<string, any>>(props: {context: Promise<IStoreWithData<T>>}){
//     const {context: promise} = props;
//     const store = use(promise);
//     const value = store?.data;
//     if(!value){
//         throw new Error("Context not provided");
//     }
//     return <>{value}</>
// }

// type TypedContextLoaderProps<T extends Record<string, any>> = {
//     context: Promise<IStoreWithData<T>>;
//     Provider: React.ComponentType<{ value: T; children?: React.ReactNode }>;
//     children?: React.ReactNode;
//   };
  
//   export function TypedContextLoader<T extends Record<string, any>>({ context, Provider, children }: TypedContextLoaderProps<T>) {
//     const store = use(context); // React 19 use() 等待 Promise 结果
//     return <Provider value={store.data}>{children}</Provider>;
//   }


export function createAsyncContextLoader<T, U>(options: {
    Provider: React.ComponentType<{ value: T; children?: React.ReactNode }>;
    extract: (u: U) => T;
    fallback?: React.ReactNode;
  }) {
    const { Provider, extract, fallback = null } = options;
  
    function AsyncContextLoaderInner(props: {
      value: Promise<U>;
      children?: React.ReactNode;
    }) {
      const raw = use(props.value);
      const contextValue = extract(raw);
      return <Provider value={contextValue}>{props.children}</Provider>;
    }
  
    return function AsyncContextLoader(props: {
      value: Promise<U>;
      children?: React.ReactNode;
    }) {
      return (
        <Suspense fallback={fallback}>
          <AsyncContextLoaderInner {...props} />
        </Suspense>
      );
    };
  }